import { documentsRoutes, documentsNavigationItems } from "@/modules/documents/router";
export class DocumentsModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[DocumentsModule] Registered");
        return { id: "documents", name: "Documents Module", version: "1.0.0" };
    }
    getRoutes() {
        return documentsRoutes;
    }
    getNavigationItems() {
        return documentsNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[DocumentsModule] Unregistered");
        this.contracts = null;
    }
}
export default new DocumentsModule();
